export default "__VITE_ASSET__C2nT0EiB__"